var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrapper',[_c('head-banner'),_c('game-preview'),_c('support-info'),_c('page-footer',{attrs:{"with-xsolla":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }